import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Plus, X, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

function CityCard({ c, reload }) {
  const [f, setF] = useState(c);
  const [nb, setNb] = useState("");
  const save = async (data = f) => {
    try { await api.put(`/admin/cities/${c.id}`, { name: data.name, lat: Number(data.lat), lng: Number(data.lng), active: data.active, neighborhoods: data.neighborhoods }); toast.success("Cidade salva"); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const addNb = () => {
    if (!nb.trim()) return;
    const next = { ...f, neighborhoods: [...f.neighborhoods, { name: nb.trim(), lat: null, lng: null }] };
    setF(next); setNb(""); save(next);
  };
  const removeNb = (name) => { const next = { ...f, neighborhoods: f.neighborhoods.filter((n) => n.name !== name) }; setF(next); save(next); };
  const del = async () => {
    if (!window.confirm(`Remover ${c.name}?`)) return;
    await api.delete(`/admin/cities/${c.id}`); reload();
  };
  return (
    <div className="po-card space-y-3" data-testid={`admin-city-${c.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <input className="po-input min-h-[48px] max-w-xs" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <label className="flex items-center gap-2 text-base font-semibold"><input type="checkbox" className="h-5 w-5 accent-orange-500" checked={f.active} onChange={(e) => setF({ ...f, active: e.target.checked })} /> Ativa</label>
        <button onClick={() => save()} className="po-btn-dark min-h-[48px] text-base">Salvar</button>
        <button onClick={del} className="po-btn-outline min-h-[48px] text-base text-red-600" aria-label="Remover cidade"><Trash2 className="h-5 w-5" /></button>
      </div>
      <div className="flex flex-wrap gap-2">
        {f.neighborhoods.map((n) => (
          <span key={n.name} className="inline-flex items-center gap-1 rounded-full bg-slate-100 py-1 pl-3 pr-1 text-base font-semibold">
            {n.name}<button onClick={() => removeNb(n.name)} className="flex h-7 w-7 items-center justify-center rounded-full hover:bg-slate-200" aria-label={`Remover ${n.name}`}><X className="h-4 w-4" /></button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input className="po-input min-h-[48px]" placeholder="Novo bairro" value={nb} onChange={(e) => setNb(e.target.value)} data-testid={`admin-city-nb-input-${c.id}`} />
        <button onClick={addNb} className="po-btn-primary min-h-[48px] text-base" data-testid={`admin-city-nb-add-${c.id}`}><Plus className="h-5 w-5" /> Bairro</button>
      </div>
      <p className="text-sm text-slate-500">Bairros novos têm a posição calculada automaticamente pelo OpenStreetMap.</p>
    </div>
  );
}

export default function AdminCities() {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ["cities"], queryFn: () => api.get("/cities").then((r) => r.data) });
  const [nf, setNf] = useState({ name: "", lat: "", lng: "" });
  const reload = () => qc.invalidateQueries({ queryKey: ["cities"] });
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/cities", { name: nf.name, lat: Number(nf.lat), lng: Number(nf.lng), active: true, neighborhoods: [] }); setNf({ name: "", lat: "", lng: "" }); reload(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="space-y-4">
      <form onSubmit={add} className="po-card grid gap-3 border-2 border-dashed border-orange-300 sm:grid-cols-4" data-testid="admin-city-add-form">
        <input className="po-input" placeholder="Nome da cidade" required value={nf.name} onChange={(e) => setNf({ ...nf, name: e.target.value })} data-testid="admin-city-new-name" />
        <input className="po-input" placeholder="Latitude (ex.: -16.68)" required type="number" step="any" value={nf.lat} onChange={(e) => setNf({ ...nf, lat: e.target.value })} data-testid="admin-city-new-lat" />
        <input className="po-input" placeholder="Longitude (ex.: -49.26)" required type="number" step="any" value={nf.lng} onChange={(e) => setNf({ ...nf, lng: e.target.value })} data-testid="admin-city-new-lng" />
        <button className="po-btn-primary" data-testid="admin-city-add-button"><Plus className="h-5 w-5" /> Adicionar cidade</button>
      </form>
      <div className="grid gap-4 lg:grid-cols-2">{data.map((c) => <CityCard key={c.id} c={c} reload={reload} />)}</div>
    </div>
  );
}
